import React from 'react'
import _ from 'lodash'
import AD from 'react-google-publisher-tag';
import { format } from 'date-fns'

import SharingFooter from './sharingFooter'

class Article extends React.Component {
  componentDidMount() {
    const articlePos = this.el.getBoundingClientRect()
    const scrollOffset = window.pageYOffset
    const yPos = {
      start: articlePos.top + scrollOffset,
      end: articlePos.bottom + scrollOffset
    }
    this.props.updatePosition(this.props.article.id, yPos)
  }

  get readTime() {
    return this.props.article.gist.readTime + 'min Read'
  }

  render() {
    //Hacky way to style articel title for PLL
    let isNotPPL = window.settings.internalName !== 'plleague'
    const { title, publishDate, landscapeImageUrl, readTime } = this.props.article.gist
    const author = _.get(this.props, 'article.contentDetails.author.name')
    const ad = this.props.ad
    const metaData = _.get(window.settings, "brand.metadata")
    return(
      <div ref={ el => this.el = el } className="article-container">
        <div className={`article__header-container ${landscapeImageUrl ? 'bg-img' : ''}`}>
          { landscapeImageUrl &&
            <img src={landscapeImageUrl} alt={title}/>
          }
          { isNotPPL && landscapeImageUrl &&
            <div className="img-gradient"/>
          }
          <div className={`article__header ${isNotPPL ? "" : "title-under-image"}`}>
            <div className="title">{ title }</div>
            <div className="details">
              <div className="details-left">
                { author && <div className="author-container">
                  <span className="by-label">By </span>
                  <span className="author">{ author }</span>
                </div>}
                {metaData && metaData.displayPublishDate && publishDate && <div>{ format(publishDate, 'MMM. D')}</div>}
                { readTime &&
                  <div>{ this.readTime }</div>
                }
              </div>
              { /*this.hasTags() &&
                <div className="details-right">
                  <span>TAGGED: </span>
                  { this.renderTags() }
                </div>
              */}
            </div>
            <div className="divider site-background-color"></div>
          </div>
        </div>
        <div className="article__body">
          { this.renderContent() }
        </div>
        { ad &&
          <div className="article__ad">
            <div className="rectangle-ad">
              <AD path={ad} dimensions={[[300,600]]}/>
            </div>
          </div>
        }
        {!window.sessionStorage.getItem('isApp') &&<SharingFooter
          path={ window.location.origin + this.props.article.gist.permalink }
          title={ this.props.article.gist.title }
        />}
      </div>
    )
  }

  hasTags() {
    return _.get(this.props, 'article.tags.length') > 0
  }

  renderTags() {
    const tags = _.map(this.props.article.tags, tag => tag.title).join(', ')
    return <span>{ tags }</span>
  }

  renderContent() {
    const innerHtml = { __html: _.get(this.props, 'article.content') }
    return <div className="content" dangerouslySetInnerHTML={ innerHtml }></div>
  }
}

export default Article
